
export const ELEMENT_NAMES = ["fire", "earth", "light", "wind", "cold", "water", "lightning", "dark"]

export const ELEMENT_COLORS_HSL = {
    fire:      { color: "hsl(10, 90%, 55%)" },       
    earth:     { color: "hsl(40, 100%, 40%)" },      
    light:     { color: "hsl(60, 100%, 80%)" },      
    wind:      { color: "hsl(120, 80%, 60%)" },     
    cold:       { color: "hsl(185, 80%, 75%)" },     
    water:     { color: "hsl(225, 90%, 55%)" },     
    lightning: { color: "hsl(275, 70%, 80%)" },    
    dark:      { color: "hsl(275, 40%, 30%)" }      
};

export const ELEMENT_COLORS = {
    "all": "#eee",
    "light-cold-water-lightning": "#ccc",
    "fire-earth-wind-dark": "#aaa",
    "fire": "#e42",
    "earth": "#c80",
    "light": "#ff9",
    "wind": "#4e4",
    "cold": "#8ee",
    "water": "#26e",
    "lightning": "#cae",
    "dark": "#436",
    "dark-fire": "#a34",
    "fire-earth": "#d61",
    "earth-light": "#eb4",
    "light-wind": "#9e6",
    "wind-cold": "#6e9",
    "cold-water": "#5ae",
    "water-lightning": "#68e",
    "lightning-dark": "#75a"
};


export const WORLD_ELEMENT_TYPES = {
    "fire": ["fire"], 
    "earth": ["earth"], 
    "light": ["light"], 
    "wind": ["wind"], 
    "cold": ["cold"], 
    "water": ["water"], 
    "lightning": ["lightning"], 
    "dark": ["dark"],
    "dark-fire": ["dark", "fire"],
    "fire-earth": ["fire", "earth"],
    "earth-light": ["earth", "light"],
    "light-wind": ["light", "wind"],
    "wind-cold": ["wind", "cold"],
    "cold-water": ["cold", "water"],
    "water-lightning": ["water", "lightning"],
    "lightning-dark": ["lightning", "dark"],
    "fire-earth-wind-dark": ["fire", "earth", "wind", "dark"],
    "light-cold-water-lightning": ["light", "cold", "water", "lightning"],
    "all": ["fire", "earth", "light", "wind", "cold", "water", "lightning", "dark"]
}